module.exports = __webpack_public_path__ + "static/media/img-talent-recommend.0a3c0d9e.png";